<template>
  <div>
    <p v-if="!landownerReport.harvest && !landownerReport.nonHarvest">
      Activity details are not required because no harvesting or non-harvesting activity was
      indicated for this reporting year.
    </p>
    <template v-else>
      <h5>Harvest Information</h5>
      <p v-if="!landownerReport.harvest">
        Harvest details are not required because no harvesting activity was indicated for this
        reporting year.
      </p>
      <template v-else>
        <DetailRow
          label="Partial cut"
          :value="getAcresString(landownerReport.partialCutHarvest)"
        />
        <DetailRow
          label="Initial/Intermediate Shelterwood Harvest"
          :value="getAcresString(landownerReport.initialShelterwoodHarvest)"
        />
        <DetailRow
          label="Final/Overstory Removal Shelterwood Harvest"
          :value="getAcresString(landownerReport.finalShelterwoodHarvest)"
        />
        <span class="text-primary mr-3">Clear Cut Harvest(s):</span>
        <ol v-if="landownerReport.clearCutHarvests.length">
          <li
            v-for="clearCutHarvest in landownerReport.clearCutHarvests"
            :key="clearCutHarvest.id"
            class="pl-2"
          >
            {{clearCutHarvest.acres}} acres
          </li>
        </ol>
        <span v-else>None</span>
        <hr class="border-dark" >
        <h5>Change of Land Use</h5>
        <p v-if="!landownerReport.landUseChangeCategoryId">
          No change of land use was indicated.
        </p>
        <DetailRow
          v-else
          :label="getLandUseName(landownerReport.landUseChangeCategoryId)"
          :value="getAcresString(landownerReport.landUseChangeArea)"
        />
      </template>
      <hr class="border-dark" >
      <h5>Non-Harvest Information</h5>
      <template v-if="!noNonHarvestActivities">
        <span class="text-primary">Herbicide Treatment:</span>
        <DetailRow
          class="ml-3"
          label="Site Preparation"
          labelClass="text-default"
          :value="getAcresString(landownerReport.sitePreperationAcres)"
        />
        <DetailRow
          class="ml-3"
          label="Release Acres"
          labelClass="text-default"
          :value="getAcresString(landownerReport.releaseAcres)"
        />
        <DetailRow
          label="Non-Commercial Thinning"
          :value="getAcresString(landownerReport.nonCommercialThinningAcres)"
        />
        <span class="text-primary mr-3">Tree Planting:</span>
        <ol v-if="landownerReport.treePlantings.length">
          <li
            v-for="treePlanting in landownerReport.treePlantings"
            :key="treePlanting.id"
            class="pl-2"
          >
            <span class="text-default mr-3">
              {{getTreeSpeciesName(treePlanting.treeSpeciesId)}}:
            </span>
            <span>{{getAcresString(treePlanting.acres)}}</span>
          </li>
        </ol>
        <span v-else>None</span>
      </template>
      <p v-else>
        No non-harvest activity was indicated.
      </p>
      <hr class="border-dark">
      <b-row>
        <b-col cols="12" :lg="4" class="text-primary">Additional Information:</b-col>
        <b-col>{{landownerReport.additionalInformation || 'None'}}</b-col>
      </b-row>
    </template>
    <b-alert v-if="landownerReport.editorCommentActivities" variant="warning" show class="mt-3">
      <strong>Editor's Comment:</strong>
      <p class="mb-0 mt-1">{{ landownerReport.editorCommentActivities }}</p>
    </b-alert>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DetailRow from '@/components/DetailRow.vue';
import LookupModules from '@/store/moduleConfig';

export default {
  name: 'ActivityDetails',
  components: {
    DetailRow,
  },
  computed: {
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapState('LandownerReport', {
      landownerReport: state => state.landownerReport,
    }),
    ...mapGetters(LookupModules.LAND_USE_CATEGORIES.namespace, {
      getLandUseName: 'getName',
    }),
    ...mapGetters(LookupModules.TREE_SPECIES.namespace, {
      getTreeSpeciesName: 'getName',
    }),
    noNonHarvestActivities() {
      return !this.landownerReport.sitePreperationAcres
        && !this.landownerReport.releaseAcres
        && !this.landownerReport.nonCommercialThinningAcres
        && !this.landownerReport.treePlantings.length;
    },
  },
  methods: {
    getAcresString(acres) {
      if (acres) {
        return `${this.$options.filters.numberString(acres)} acres`;
      }
      return '0 acres';
    },
  },
};
</script>
